import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[rotaDisable]',
    standalone: false
})
export class ComponentStylingDirective {

    @Input() opacity: number = 0.55;

    @Input() set rotaDisable(value: boolean) {
        if (value) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', this.opacity);
            this.renderer.setStyle(this.elementRef.nativeElement, 'user-select', 'none');
            this.renderer.setStyle(this.elementRef.nativeElement, 'pointer-events', 'none');
        }
        else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', null);
            this.renderer.setStyle(this.elementRef.nativeElement, 'user-select', null);
            this.renderer.setStyle(this.elementRef.nativeElement, 'pointer-events', null);
        }
    };

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) { }
}